<script setup>
import { ref } from "vue";
import PageHeader from '@/Components/PageHeader.vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";
defineProps({
    typedocs: Array
});
const rutaPrefijo = ref('typedoc');
</script>

<template>
    <Head title="Config. Tipo de documentos" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Tipo de documentos">
                <template #actions>
                    <Link :href="route('typedoc.create')">
                        <BaseButton color="info" label="Nuevo documento" :icon="mdiPlusCircle" />
                    </Link>
                </template>
            </PageHeader>
        </template>

        <div class="py-8 lg:py-10">
            <div class="mx-auto sm:px-6 lg:px-8 px-4">
                <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                    <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                    <CardBox class="mb-6" has-table>
                        <!-- Tablesingle opciones: checkable -->
                        <TableSingle isRef :data="typedocs" :ruta="rutaPrefijo" />
                    </CardBox>

                </div>
            </div>

        </div>
    </BreezeAuthenticatedLayout>
</template>
